import { render, staticRenderFns } from "./RequirementsTree.vue?vue&type=template&id=5ec0c910&"
import script from "./RequirementsTree.vue?vue&type=script&lang=js&"
export * from "./RequirementsTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports